import { api } from '@/lib/api';
import type { PortfolioCategory } from '@lentera/shared';

export interface PortfolioRow {
  id: string;
  individualId: string;
  category: PortfolioCategory;
  title: string;
  description: string | null;
  dateOrYear: string | null;
  linkUrl: string | null;
  fileKey: string | null;
  fileName: string | null;
  fileSizeBytes: number | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export const portfolioApi = {
  list: (params: { individualId: string; category?: PortfolioCategory }) => {
    const search = new URLSearchParams({ individualId: params.individualId });
    if (params.category) search.set('category', params.category);
    return api.get<PortfolioRow[]>(`/portfolios?${search}`);
  },
  create: (data: {
    individualId: string;
    category: PortfolioCategory;
    title: string;
    description?: string | null;
    dateOrYear?: string | null;
    linkUrl?: string | null;
    fileKey?: string | null;
    fileName?: string | null;
    fileSizeBytes?: number | null;
  }) => api.post<PortfolioRow>('/portfolios', data),
  update: (
    id: string,
    data: Partial<{
      category: PortfolioCategory;
      title: string;
      description: string | null;
      dateOrYear: string | null;
      linkUrl: string | null;
      fileKey: string | null;
      fileName: string | null;
      fileSizeBytes: number | null;
    }>,
  ) => api.patch<PortfolioRow>(`/portfolios/${id}`, data),
  remove: (id: string) => api.del<{ success: boolean; id: string }>(`/portfolios/${id}`),
};
